import { computed, reactive, readonly, ref } from "vue";
import { api, ServerError, setUnauthorizedHandler } from "@/api/server";

/**
 * Anmeldezustand des Dashboards. Der Server setzt ein HttpOnly-Cookie; die SPA
 * kennt nur "angemeldet als wer" und faellt bei 401 zurueck auf die Login-Maske.
 */

const user = ref<string | null>(null);
const checked = ref(false);

/** Fragt den Server, ob die aktuelle Sitzung gueltig ist. */
export async function refreshSession(): Promise<void> {
  try {
    const me = await api.me();
    user.value = me.authenticated ? (me.user ?? "") : null;
  } catch {
    user.value = null;
  } finally {
    checked.value = true;
  }
}

/** Meldet an; wirft {@link ServerError} mit Klartextmeldung bei falschen Daten. */
export async function login(name: string, password: string): Promise<void> {
  const result = await api.login(name, password);
  user.value = result.user ?? name;
}

export async function logout(): Promise<void> {
  try {
    await api.logout();
  } finally {
    user.value = null;
  }
}

// Meldet der Server 401, zurueck zur Login-Maske (Cookie abgelaufen oder ungueltig).
setUnauthorizedHandler(() => {
  user.value = null;
  checked.value = true;
});

export const auth = readonly(
  reactive({
    user,
    checked,
    isAuthenticated: computed(() => user.value !== null),
  }),
);

export { ServerError };
